import { ChatActions, ContentTypes, MessageMetaContent } from 'api/support'

const pastBookingActions = [ChatActions.RESEND_CONFIRMATION_EMAIL, ChatActions.CANCEL_ORDER, ChatActions.CHANGE_ROOM, ChatActions.CHANGE_DATES]

export const filterActions = (action: any, isPastBooking: boolean, skipActions: string[] = []) => {
  const actionsToSkip = isPastBooking ? [...pastBookingActions, ...skipActions] : skipActions
  return isChip(action) && !actionsToSkip.includes(action?.action?.key)
}

export const isChip = (action: MessageMetaContent) => action?.type === ContentTypes.BUTTON
export const isComponent = (action: MessageMetaContent) => action?.type !== ContentTypes.BUTTON
